import api from './api'

const updateNfcTagsForCurrentUser = (tags: Tag[]): Promise<unknown> =>
    api<unknown>({ method: 'PUT', path: '/users/nfctags/own', body: tags })

export default updateNfcTagsForCurrentUser

export type Tag = {
    id: string
    comment?: string
}
